var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgStar = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 25, height: 23.439 }, props, { children: _jsx("path", { "data-name": "Path 18", d: "M4.476 22.423a.829.829 0 0 0 1.166.926l6.855-3.524 6.857 3.525a.829.829 0 0 0 1.166-.925l-1.3-7.391 5.5-5.243a.869.869 0 0 0-.442-1.484l-7.641-1.088L13.224.458a.8.8 0 0 0-1.449 0L8.363 7.22.71 8.308a.869.869 0 0 0-.442 1.484l5.5 5.243-1.3 7.391Zm7.663-4.323-5.758 2.959 1.084-6.181a.883.883 0 0 0-.255-.789L2.67 9.761l6.327-.902a.82.82 0 0 0 .614-.45l2.886-5.715 2.885 5.715a.82.82 0 0 0 .614.45l6.331.9-4.54 4.328a.881.881 0 0 0-.255.791l1.084 6.182-5.759-2.959a.786.786 0 0 0-.72 0Z", fillRule: "evenodd", opacity: 0.5 }) }))); };
export default SvgStar;
